import { useState } from 'react'
import Modal from '@/components/ui/Modal'
import { ModalFooter } from '@/components/ui/ConfirmModal'
import { useGeneratePaymentLink } from '@/api/hooks/appointments.hooks'
import { toastCallbacks } from '@/api/hooks/useMutationWithToast'
import { toast } from '@/hooks/use-toast'

type GeneratePaymentLinkModalProps = {
  appointmentId: string
  onClose: () => void
}

export function GeneratePaymentLinkModal({ appointmentId, onClose }: GeneratePaymentLinkModalProps) {
  const generatePaymentLink = useGeneratePaymentLink()
  const [link, setLink] = useState('')

  if (!link && !generatePaymentLink.isPending) {
    const { onError } = toastCallbacks({ onError: 'Failed' })
    generatePaymentLink.mutate(
      { appointmentId },
      { onSuccess: (data) => setLink(data), onError }
    )
  }

  const handleCopy = async () => {
    await navigator.clipboard.writeText(link)
    toast({ title: 'Link copied to clipboard' })
  }

  return (
    <Modal isOpen onClose={onClose} title='Generate Save-Card Link'>
      <div className='space-y-6'>
        <div className='space-y-2'>
          <p className='text-sm text-muted-foreground'>Send this link to the patient to save their card. It doesn't charge them — confirm the appointment afterwards to charge the $50 approval fee.</p>
          {link ? (
            <div className='rounded-lg border border-border/70 bg-muted/30 p-3 text-sm break-all'>{link}</div>
          ) : (
            <p className='text-sm text-muted-foreground'>Generating link...</p>
          )}
        </div>
        <ModalFooter
          secondaryLabel='Close'
          onClose={onClose}
          primaryLabel={link ? 'Copy Link' : undefined}
          onPrimary={link ? handleCopy : undefined}
        />
      </div>
    </Modal>
  )
}
